import { ChainedSchema } from '../general/ChainedSchema';
class SerializrType_onlyDbEntities extends ChainedSchema {
    deserializer(context) {
        if (!dbEntityTypes.includes(context.objectContext.target.type)) {
            return undefined;
        }
        return this.parentSchema.deserializer(context);
    }
}
export function onlyDbEntities(propSchema) {
    return new SerializrType_onlyDbEntities(propSchema);
}
export const dbEntityTypes = [
    'app',
    'public',
    'relate',
    'personal',
    'bundle',
    'question',
    'answer',
    'onlinecounter',
    'topic',
    'path',
    'user',
    'reward'
];
